import React, { createContext, useContext, useState } from "react"
import { useScreenSize } from "../../../hook/useScreenSize"

interface SidebarContextType {
    isXSmall: boolean
    isSidebarExpanded: boolean
    toggleSidebar: () => void
    hide(): void
    show(): void
}

const SidebarContext = createContext<SidebarContextType | undefined>(undefined)

export const SidebarProvider = ({ children }: { children: React.ReactNode }) => {
    const { isXSmall } = useScreenSize()
    const [isSidebarExpanded, setIsSidebarExpanded] = useState(!isXSmall)

    const toggleSidebar = () => {
        setIsSidebarExpanded((prev) => !prev)
    }

    const hide = () => {
        setIsSidebarExpanded(false)
    }

    const show = () => {
        setIsSidebarExpanded(true)
    }

    return (
        <SidebarContext.Provider value={{
            isXSmall,
            isSidebarExpanded,
            toggleSidebar,
            hide,
            show}}>
            {children}
        </SidebarContext.Provider>
    )
}

export const useSidebar = () => {
    const context = useContext(SidebarContext)

    if (!context) {
        throw new Error("useSidebar must be used within a SidebarProvider")
    }

    return context
}
